/**
 * @generated SignedSource<<b39558cefe1da005ff4a83abf9144169>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildApprovalReviewers_approvalUser$data = {
  readonly id: number | null | undefined;
  readonly name: string | null | undefined;
  readonly username: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
  readonly " $fragmentType": "BuildApprovalReviewers_approvalUser";
};
export type BuildApprovalReviewers_approvalUser$key = {
  readonly " $data"?: BuildApprovalReviewers_approvalUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildApprovalReviewers_approvalUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildApprovalReviewers_approvalUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "769062a56ccfbd2c6d74d23dd7ba62c7";

export default node;
